import MiniWidget from './MiniWidget';
export type { MiniWidgetProps } from './MiniWidget.types';
export default MiniWidget;
